import { IUpdateTenant, TenantEntity } from '@/interfaces';
import { DefaultEntity } from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { CustomResponse } from './type';
import { SignedUrlPayload } from '@/queries/user.query';

class OrganizationServiceClass extends BaseService<
  'organization',
  TenantEntity,
  DefaultEntity
> {
  constructor() {
    super('tenants');
  }

  getOrgBySubdomain = (subdomain: string): Promise<TenantEntity> => {
    return APIService.get(this.path + '/subdomain', { params: { subdomain } });
  };

  updateOrg = (payload: {
    id: string;
    data: IUpdateTenant;
  }): Promise<CustomResponse<TenantEntity>> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };

  generateManySignedUrls = (files: SignedUrlPayload[]): Promise<any> => {
    return APIService.post(this.path + '/files/signed-urls', files);
  };

  generateManyPresignedUrls = (paths: string[]): Promise<any> => {
    return APIService.post(this.path + '/files/many-presigned-urls', {
      paths,
    });
  };
}

export const orgService = new OrganizationServiceClass();
